/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Media_Images1Inputs */

const id_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gambar`)
};

const ms_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imej`)
};

const da_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billeder`)
};

const de_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder`)
};

const en_us2_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Images`)
};

const es_es2_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imágenes`)
};

const es_mx2_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imágenes`)
};

const fil_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Larawan`)
};

const fr_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Images`)
};

const it_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immagini`)
};

const hu_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Képek`)
};

const nl_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afbeeldingen`)
};

const no_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder`)
};

const pl_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrazy`)
};

const pt_br2_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagens`)
};

const pt_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagens`)
};

const ro_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagini`)
};

const fi_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuvat`)
};

const sv_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder`)
};

const vi_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hình ảnh`)
};

const tr_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görseller`)
};

const cs_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrázky`)
};

const bg_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изображения`)
};

const ru_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изображения`)
};

const uk_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зображення`)
};

const ar_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصور`)
};

const hi_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छवियाँ`)
};

const th_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รูปภาพ`)
};

const ja_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像`)
};

const zh_cn2_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图像`)
};

const zh_hant1_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圖像`)
};

const ko_offerdetail_media_images1 = /** @type {(inputs: Offerdetail_Media_Images1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미지`)
};

/**
* | output |
* | --- |
* | "Images" |
*
* @param {Offerdetail_Media_Images1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_media_images1 = /** @type {((inputs?: Offerdetail_Media_Images1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Media_Images1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_media_images1(inputs)
	if (locale === "ms") return ms_offerdetail_media_images1(inputs)
	if (locale === "da") return da_offerdetail_media_images1(inputs)
	if (locale === "de") return de_offerdetail_media_images1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_media_images1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_media_images1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_media_images1(inputs)
	if (locale === "fil") return fil_offerdetail_media_images1(inputs)
	if (locale === "fr") return fr_offerdetail_media_images1(inputs)
	if (locale === "it") return it_offerdetail_media_images1(inputs)
	if (locale === "hu") return hu_offerdetail_media_images1(inputs)
	if (locale === "nl") return nl_offerdetail_media_images1(inputs)
	if (locale === "no") return no_offerdetail_media_images1(inputs)
	if (locale === "pl") return pl_offerdetail_media_images1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_media_images1(inputs)
	if (locale === "pt") return pt_offerdetail_media_images1(inputs)
	if (locale === "ro") return ro_offerdetail_media_images1(inputs)
	if (locale === "fi") return fi_offerdetail_media_images1(inputs)
	if (locale === "sv") return sv_offerdetail_media_images1(inputs)
	if (locale === "vi") return vi_offerdetail_media_images1(inputs)
	if (locale === "tr") return tr_offerdetail_media_images1(inputs)
	if (locale === "cs") return cs_offerdetail_media_images1(inputs)
	if (locale === "bg") return bg_offerdetail_media_images1(inputs)
	if (locale === "ru") return ru_offerdetail_media_images1(inputs)
	if (locale === "uk") return uk_offerdetail_media_images1(inputs)
	if (locale === "ar") return ar_offerdetail_media_images1(inputs)
	if (locale === "hi") return hi_offerdetail_media_images1(inputs)
	if (locale === "th") return th_offerdetail_media_images1(inputs)
	if (locale === "ja") return ja_offerdetail_media_images1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_media_images1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_media_images1(inputs)
	return ko_offerdetail_media_images1(inputs)
});
export { offerdetail_media_images1 as "offerDetail.media.images" }